export const BUILD_PROTECTION_SECTION_ID = "build-protection";

export const BUILD_PROTECTION_TAB_PARAM = "buildProtectionTab";

export const BUILD_PROTECTION_TAB_IDS = [
  "buildMySystem",
  "securityKits",
  "cameras",
  "monitoring",
] as const;

export type BuildProtectionTabId = (typeof BUILD_PROTECTION_TAB_IDS)[number];

export const BUILD_PROTECTION_ITEM_LIST_ID = "homepage_build_protection";
export const BUILD_PROTECTION_ITEM_LIST_NAME = "build_protection";

export const BUILD_PROTECTION_SURFACE_SHADOW =
  "shadow-[0_6px_20px_rgba(0,34,106,0.1)]";

export const isBuildProtectionTabId = (
  value: string | null | undefined,
): value is BuildProtectionTabId =>
  BUILD_PROTECTION_TAB_IDS.some((tabId) => tabId === value);
